import React from "react";
import "./blogPosts.css";
import FontAwesome from "react-fontawesome";
import { FormattedMessage } from "react-intl";
import { wordpressBlogPosts } from "../../app/AppHelpers";

class BlogPosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = { blogPosts: [] };
  }

  componentDidMount() {
    fetch(wordpressBlogPosts)
      .then(response => response.json())
      .then(response => {
        this.setState({
          blogPosts: response
        });
      });
  }
  render() {
    let posts = this.state.blogPosts;
    let postLoop = posts.map((post, index) => {
      return (
        <li key={index}>
          <a href={post.link}>
            <FontAwesome name="rss" style={{ paddingTop: 5 }} />{" "}
            {post.title.rendered}
          </a>
        </li>
      );
    });

    return (
      <ul className="blogPosts">
        {postLoop}
        <a
          href="https://blog.opseeker.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="morePosts"
        >
          <FormattedMessage id="General.More" defaultMessage="More" />
        </a>
      </ul>
    );
  }
}

export default BlogPosts;



// WEBPACK FOOTER //
// ./src/containers/blogPosts/BlogPosts.js